module.exports = __webpack_public_path__ + "media/img/Landing_Page/logos/14-270117eaf6fa97e81acd54729a423715.jpg";